setInterval(() => {
  const elements = document.querySelectorAll(".upcart-item-property");

  elements.forEach((element) => {
    const content = element.textContent || element.innerText;
    if (
      content.includes("_customization_id") ||
      content.includes("customization_id")
    ) {
      element.remove();
    }
  });
}, 500);